import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ReportService } from '../../services/report/report.service';
import { first, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ReportRequestsChartResolve implements Resolve<any> {

    constructor(private rs: ReportService) { }

    resolve(route: ActivatedRouteSnapshot) {
        let from = route.queryParams['from'];
        let to = route.queryParams['to'];
        return this.rs.getRequestsChart(from, to).pipe(map(charts => charts)).pipe(first());
    }

}
